import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { PublicMerchCardLayoutUI } from './PublicMerchCardLayoutUI';
import { SingleSkeletonLoader } from 'pricing-pages-ui-components/loading/SingleSkeletonLoader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PublicMerchCardSkeleton = ({
  columnStart,
  'data-test-id': dataTestId = 'public-merch-card-skeleton'
}) => {
  return /*#__PURE__*/_jsx(PublicMerchCardLayoutUI, {
    "data-selenium-id": dataTestId,
    columnStart: columnStart,
    Title: /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 28,
      width: "50%"
    }),
    Subheading: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "200",
      children: [/*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 14
      }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 14,
        width: "90%"
      }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 14,
        width: "85%"
      }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 14,
        width: "40%"
      })]
    }),
    Pricing: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "200",
      children: [/*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 12,
        width: "25%"
      }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 36,
        width: "55%"
      }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 14,
        width: "35%"
      })]
    }),
    BelowPrice: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "200",
      children: [/*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 16,
        width: "60%"
      }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 14,
        width: "70%"
      })]
    }),
    Term: /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 52
    }),
    CTAs: /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 44
    }),
    BelowCTA: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "200",
      children: [/*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 14,
        width: "55%"
      }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 14,
        width: "45%"
      })]
    }),
    Features: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "200",
      children: [/*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 14,
        width: "60%"
      }), /*#__PURE__*/_jsx(View, {
        paddingBlockStart: "200",
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "300",
          children: [/*#__PURE__*/_jsx(SingleSkeletonLoader, {
            height: 22,
            width: "70%"
          }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
            height: 22,
            width: "80%"
          }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
            height: 22,
            width: "65%"
          }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
            height: 22,
            width: "75%"
          }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
            height: 22,
            width: "60%"
          }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
            height: 22,
            width: "85%"
          }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
            height: 22,
            width: "70%"
          }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
            height: 22,
            width: "55%"
          }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
            height: 22,
            width: "75%"
          })]
        })
      })]
    }),
    Footer: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "100",
      children: [/*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 12,
        width: "95%"
      }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 12,
        width: "80%"
      }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 12,
        width: "30%"
      })]
    })
  });
};